var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.post
    ? _c(
        "div",
        [
          _vm.userAnswer
            ? _c(
                "div",
                { staticClass: "block" },
                [
                  _c(
                    "router-link",
                    { attrs: { to: `/user/drills/${_vm.userAnswer.drillId}` } },
                    [
                      _c("i", { staticClass: "fas fa-chevron-left" }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$t("term.answers")))]),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("h1", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("term.explanation"))),
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "div",
              [
                _c("h3", { staticClass: "title is-5" }, [
                  _vm._v(_vm._s(_vm.$t("term.question"))),
                ]),
                _vm._v(" "),
                _c("post-content", {
                  attrs: { post: _vm.post, "is-disp-title": false },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "block mt-6" }, [
                  _c("h3", { staticClass: "title is-5" }, [
                    _vm._v(_vm._s(_vm.$t("term.yourAnswer"))),
                  ]),
                  _vm._v(" "),
                  _vm.post.answerType === "text"
                    ? _c("div", { staticClass: "block" }, [
                        _c("div", [
                          _vm.userAnswerImageUrl
                            ? _c("div", [
                                _c(
                                  "figure",
                                  { staticClass: "image is-block" },
                                  [
                                    _c("img", {
                                      attrs: { src: _vm.userAnswerImageUrl },
                                    }),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.userAnswerImageUrls
                            ? _c("div", [
                                _c(
                                  "ul",
                                  _vm._l(
                                    _vm.userAnswerImageUrls,
                                    function (url) {
                                      return _c(
                                        "li",
                                        {
                                          key: url,
                                          staticClass: "mb-4 relative",
                                        },
                                        [
                                          _c(
                                            "figure",
                                            { staticClass: "image is-block" },
                                            [_c("img", { attrs: { src: url } })]
                                          ),
                                          _vm._v(" "),
                                          _c("button", {
                                            staticClass:
                                              "delete absolute top-4 right-4",
                                            on: {
                                              click: function ($event) {
                                                return _vm.deleteUploadedFile(
                                                  url
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _c("FileInput", {
                                attrs: {
                                  "uploader-options": _vm.uploaderOptions,
                                  "is-draggable": true,
                                },
                                model: {
                                  value: _vm.files,
                                  callback: function ($$v) {
                                    _vm.files = $$v
                                  },
                                  expression: "files",
                                },
                              }),
                              _vm._v(" "),
                              _vm.thumbnails.length > 0
                                ? _c("div", [
                                    _c(
                                      "ul",
                                      {
                                        staticClass:
                                          "columns is-multiline is-tablet",
                                      },
                                      _vm._l(
                                        _vm.thumbnails,
                                        function (thumbnail, index) {
                                          return _c(
                                            "li",
                                            {
                                              key: index,
                                              staticClass:
                                                "column is-half relative",
                                            },
                                            [
                                              _c("button", {
                                                staticClass:
                                                  "delete absolute top-4 right-4",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.deleteFile(index)
                                                  },
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("img", {
                                                attrs: {
                                                  src: thumbnail,
                                                  alt: "Thumbnail",
                                                },
                                              }),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                    _vm._v(" "),
                                    _c("div", [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "button is-info",
                                          on: { click: _vm.uploadFiles },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(_vm.$t("common.send")) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.userAnswer.answer
                            ? _c("div", { staticClass: "pre-wrap" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.userAnswer.answer) +
                                    "\n            "
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "mt-20" },
                          [
                            _c(
                              "b-radio",
                              {
                                attrs: { "native-value": "1" },
                                on: {
                                  input: function ($event) {
                                    return _vm.updateCorrectState()
                                  },
                                },
                                model: {
                                  value: _vm.isCorrect,
                                  callback: function ($$v) {
                                    _vm.isCorrect = $$v
                                  },
                                  expression: "isCorrect",
                                },
                              },
                              [
                                _c("correct-status", {
                                  attrs: {
                                    "is-correct": true,
                                    "is-bold": false,
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-radio",
                              {
                                staticClass: "ml-3",
                                attrs: { "native-value": "0" },
                                on: {
                                  input: function ($event) {
                                    return _vm.updateCorrectState()
                                  },
                                },
                                model: {
                                  value: _vm.isCorrect,
                                  callback: function ($$v) {
                                    _vm.isCorrect = $$v
                                  },
                                  expression: "isCorrect",
                                },
                              },
                              [
                                _c("correct-status", {
                                  attrs: {
                                    "is-correct": false,
                                    "is-bold": false,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.post.answerType === "select"
                    ? _c(
                        "div",
                        [
                          _c(
                            "span",
                            { staticClass: "has-text-weight-semibold" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.answerLabels[_vm.userAnswerIndex]
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("correct-status", {
                            attrs: { "is-correct": _vm.userAnswer.isCorrect },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "block mt-6" }, [
                  _c("h3", { staticClass: "title is-5 is-clearfix mb-2" }, [
                    _c("span", [_vm._v(_vm._s(_vm.$t("common.comment")))]),
                    _vm._v(" "),
                    _vm.isEditComment === false
                      ? _c(
                          "button",
                          {
                            staticClass: "button is-ghost is-pulled-right",
                            on: {
                              click: function ($event) {
                                _vm.isEditComment = true
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("common.edit")) +
                                "\n          "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _vm.isEditComment
                    ? _c(
                        "div",
                        [
                          _c("b-input", {
                            attrs: { type: "textarea" },
                            model: {
                              value: _vm.comment,
                              callback: function ($$v) {
                                _vm.comment = $$v
                              },
                              expression: "comment",
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "buttons mt-2" }, [
                            _c(
                              "button",
                              {
                                staticClass: "button is-info",
                                on: {
                                  click: function ($event) {
                                    return _vm.saveComment()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("common.save")) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "button is-light",
                                on: {
                                  click: function ($event) {
                                    _vm.isEditComment = false
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("common.cancel")) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]),
                        ],
                        1
                      )
                    : _c("div", { staticClass: "block" }, [
                        _vm.userAnswer.answerComment
                          ? _c("div", { staticClass: "pre-wrap" }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.userAnswer.answerComment) +
                                  "\n          "
                              ),
                            ])
                          : _c("div", [
                              _vm._v(_vm._s(_vm.$t("common.unregistered"))),
                            ]),
                      ]),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", [
              _c(
                "div",
                { staticClass: "block" },
                [
                  _c("h3", { staticClass: "title is-5" }, [
                    _vm._v(_vm._s(_vm.$t("term.answer"))),
                  ]),
                  _vm._v(" "),
                  _vm.post.answerType === "text"
                    ? _c("div", { staticClass: "block" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.post.correctAnswerText) +
                            "\n        "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.post.answerType == "select"
                    ? _c("select-type-answers-content", {
                        attrs: {
                          answers: _vm.post.answersHtml,
                          "correct-answer": _vm.post.correctAnswer,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "block mt-6" },
                [
                  _c("h3", { staticClass: "title is-5" }, [
                    _vm._v(_vm._s(_vm.$t("form.answerExplanation"))),
                  ]),
                  _vm._v(" "),
                  _c("html-content", {
                    staticClass: "mt-2",
                    attrs: { body: _vm.post.answerExplanationHtml },
                  }),
                  _vm._v(" "),
                  "answerExpImages" in _vm.post &&
                  _vm.post.answerExpImages.length > 0
                    ? _c(
                        "ul",
                        _vm._l(_vm.post.answerExpImages, function (image) {
                          return _c(
                            "li",
                            { key: image.fileId, staticClass: "image" },
                            [
                              _c("fb-img", {
                                staticClass: "mt-4",
                                attrs: {
                                  fileId: image.fileId,
                                  mimeType: image.mimeType,
                                  "media-service-id": _vm.post.serviceId,
                                  size: "raw",
                                },
                              }),
                            ],
                            1
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("UserEditMasterStatus", {
            attrs: {
              "post-service-id": _vm.postServiceId,
              "post-id": _vm.postId,
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }